import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import { Table } from "antd";
import BaseCard from "../../components/card/BaseCard";
import { Icon } from "@iconify/react";
import BaseTable from "../../components/BaseTable";
import type { TableProps } from "antd/lib";
import StatusVisit from "../../components/StatusVisit";
import ButtonIcon from "../../components/ButtonIcon";
import ConfirmModal from "../../components/modal/ConfirmModal";
import { Link, useParams } from "react-router";
import { $api, type components } from "../../helper";
import { statusMock, tokenMock } from "../../helper/mock";
import ButtonLinkIcon from "../../components/ButtonLinkIcon";
import { useNotify } from "../../helper/notify";
import { GetFullMediaPath } from "../../helper/method";
import FilterSearch from "../../components/filter/FilterSearch";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import ButtonIconSvg from "../../components/ButtonIconSvg";
import Trash from "../../components/svg/Trash";
import ButtonLinkIconSvg from "../../components/ButtonLinkIconSvg";
import PenSquare from "../../components/svg/PenSquare";

export default function SubCategory() {
  const [isOpen, setIsOpen] = useState(false);
  const notify = useNotify();
  const params = useParams();
  const deleteCat = $api.useMutation("delete", "/site-api/v1/course/category/");
  const [id, setId] = useState("");
  const { data, isPending, mutate } = $api.useMutation(
    "get",
    "/site-api/v1/course/category/",
  );

  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("دسته بندی دوره ها");
    mutate({
      params: {
        query: {
          department_slug: params.departmentId ?? "",
        },
      },
      headers: {
        Authorization: tokenMock,
        lang: "fa",
      },
    });
  }, []);

  useEffect(() => {
    mutate({
      params: {
        query: {
          department_slug: params.departmentId ?? "",
          category_u_id: params["*"] ?? "",
        },
      },
      headers: {
        Authorization: tokenMock,
        lang: "fa",
      },
    });
  }, [params]);

  const columns: TableProps<
    components["schemas"]["SiteCourseCategoryItem"]
  >["columns"] = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (_, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "تصویر دسته بندی",
      dataIndex: "desktop_image",
      key: "desktop_image",
      render: (_, record) => (
        <div className="aspect-square w-16 rounded-lg overflow-hidden">
          <img
            src={GetFullMediaPath(record.desktop_image)}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      ),
    },
    {
      title: "عنوان دسته بندی",
      dataIndex: "title",
      key: "title",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterSearch
          clearFilters={clearFilters}
          confirm={confirm}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
        />
      ),
      onFilter: (value, record) =>
        record?.title
          ?.toLowerCase()
          ?.includes(value.toString().toLocaleLowerCase()),
      filterIcon: () => (
        <Icon className="text-xl" icon={"solar:magnifer-linear"} />
      ),
    },
    {
      title: "تعداد دسته بندی",
      dataIndex: "category_count",
      key: "category_count",
    },
    {
      title: "نمایش در سایت",
      key: "show",
      dataIndex: "show",
      filters: statusMock,
      onFilter: (value, record) =>
        record.status.toString().indexOf(value as string) === 0,
      render: (_, record) => <StatusVisit status={record.status} />,
    },
    {
      title: "عملیات",
      key: "action",
      render: (_, record) => (
        <div className="flex items-center gap-2">
          <Link
            to={`/department-category/${params.departmentId}/${record.u_id}`}
          >
            نمایش زیر دسته ها
          </Link>
          {/* <ButtonLinkIcon
            to={{
              pathname: `/department-category/${params.departmentId}/${record.u_id}/add-sub-category`,
              search:
                params["*"]?.length === 0
                  ? `?method=update-department&name=${data?.data?.parents?.find((e) => e.u_id === params.departmentId)?.title}`
                  : `?method=update&name=${data?.data?.parents?.find((e) => e.u_id === params["*"])?.title}&parent=${params["*"]}`,
            }}
            icon="solar:pen-new-square-linear"
            className="text-primary-500!"
          /> */}
          <ButtonLinkIconSvg
            icon={<PenSquare />}
            to={{
              pathname: `/department-category/${params.departmentId}/${record.u_id}/add-sub-category`,
              search:
                params["*"]?.length === 0
                  ? `?method=update-department&name=${data?.data?.parents?.find((e) => e.u_id === params.departmentId)?.title}`
                  : `?method=update&name=${data?.data?.parents?.find((e) => e.u_id === params["*"])?.title}&parent=${params["*"]}`,
            }}
            className="text-primary-500!"
          />
          {/* <ButtonIcon
            icon="solar:trash-bin-trash-linear"
            className="text-error-500!"
            onClick={() => {
              setId(record.u_id);
              setIsOpen(true);
            }}
          /> */}
          <ButtonIconSvg
            icon={<Trash />}
            className="text-error-500!"
            onClick={() => {
              setId(record.u_id);
              setIsOpen(true);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      {/* modal */}
      <ConfirmModal
        pending={deleteCat.isPending}
        title="حذف از دسته بندی ها ؟"
        description="حذف این دسته‌بندی باعث عدم نمایش آن در بخش‌های مرتبط می‌شود."
        action={() => {
          deleteCat.mutate(
            {
              params: {
                query: {
                  category_u_id: id,
                },
              },
              headers: {
                Authorization: tokenMock,
                lang: "fa",
              },
            },
            {
              onSuccess: (data) => {
                notify.success(data.message);
                setId("");
                setIsOpen(false);
                mutate({
                  params: {
                    query: {
                      department_slug: params.departmentId ?? "",
                    },
                  },
                  headers: {
                    Authorization: tokenMock,
                    lang: "fa",
                  },
                });
              },
            },
          );
        }}
        open={isOpen}
        onClose={() => {
          setId("");
          setIsOpen(false);
        }}
      />
      <div className="w-full flex justify-between sm:flex-row sm:gap-0 gap-4 flex-col sm:items-center items-start">
        <CustomBreadcrumb
          items={[
            {
              title: "دپارتمان ها",
              href: "/department-category",
            },
            ...(data?.data?.parents?.map((e, i) => ({
              title: e.title,
              href:
                i > 0
                  ? `/department-category/${params.departmentId}/${e.u_id}`
                  : `/department-category/${params.departmentId}`,
            })) ?? []),
          ]}
        />
        <Link
          to={{
            pathname: `/department-category/${params.departmentId}/${params["*"]}/add-sub-category`,
            search:
              params["*"]?.length === 0
                ? `?method=add-department&name=${data?.data?.parents?.find((e) => e.u_id === params.departmentId)?.title}`
                : `?method=add&name=${data?.data?.parents?.find((e) => e.u_id === params["*"])?.title}`,
          }}
          className="button-style"
        >
          ایجاد دسته بندی دوره
        </Link>
      </div>

      <div>
        <BaseCard props={{ className: "flex-1 flex-col flex gap-6" }}>
          <BaseTable props={{ className: "w-full grid! grid-cols-1!" }}>
            <Table<components["schemas"]["SiteCourseCategoryItem"]>
              columns={columns}
              dataSource={data?.data.categories}
              loading={isPending}
              className="col-span-1!"
              scroll={{ x: "max-content" }}
            />
          </BaseTable>
        </BaseCard>
      </div>
    </div>
  );
}
